const EMAIL_WITH_DOMAIN_SEGMENT_REGEX =
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function isValidEmail(value) {
	const trimmedValue = typeof value === 'string' ? value.trim() : '';
	if (!trimmedValue) {
		return false;
	}
	return EMAIL_WITH_DOMAIN_SEGMENT_REGEX.test(trimmedValue);
}

export function isRequiredTrimmed(value) {
	return typeof value === 'string' && value.trim().length > 0;
}
